import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/api';
import { CommonService } from 'src/app/shared/common.service';
import { TokenStorageService } from 'src/app/shared/token-storage';

@Component({
  selector: 'password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
})
export class PasswordResetComponent implements OnInit {
  form: any = {
    email: '', // 'andreas@die.app',
    lost: false,
    password: '',// 'andreas@die.app'
  }
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];

  error: boolean = false;

  constructor(
    public commonService: CommonService,
    private apiService: ApiService,
    public router: Router,
    public activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {

  }

  resetPassword() {
    const { password, password2, email } = this.form;

    console.log(this.form)
    this.error = false

    if (password !== password2) {
      this.error = true
      this.errorMessage = 'Passwort und Passwortwiederholung stimmen nicht überein.'
      return
    } 

    let token = this.activatedRoute.snapshot.paramMap.get('token')
    this.apiService
      .resetPassword(email, token, password)
      .subscribe(
        data => {
          this.errorMessage = ''
          this.router.navigateByUrl("/login")
        },
        err => {
          console.log(err)
          this.error = true
          this.errorMessage = err.error.error
        }
      );
  }


}
